import React, { useEffect } from 'react'

import Script from 'next/script'

import LogService from 'services/LogService'

import { handleG2Enrich } from './utils'

const G2CompanyLookup = ({ apiKey, url, showCached = false }) => {
  useEffect(() => {
    window.g2EnrichCallback = response => {
      try {
        handleG2Enrich(response)
      } catch (error) {
        LogService.error(`[G2CompanyLookup] Failed to push event: ${error}`)
      }
    }

    return () => {
      window.g2EnrichCallback = undefined
    }
  }, [])

  const searchParams = new URLSearchParams({
    authorization: apiKey,
    callback: 'g2EnrichCallback',
  })

  if (showCached) searchParams.append('test', 'cache_hit')

  const enrichUrl = `${url}?${searchParams.toString()}`

  return (
    <Script
      id="g2-company-lookup"
      src={enrichUrl}
      strategy="afterInteractive"
      onError={e => {
        LogService.error(`[G2CompanyLookup] Script failed to load: ${e}`)
      }}
    />
  )
}

export default G2CompanyLookup
